export const MENU_ROUTE_FILTER_ID_SET = 'MENU_ROUTE_FILTER_ID_SET';
export const MENU_ROUTE_INIT_COLLAPSIBLE = 'MENU_ROUTE_INIT_COLLAPSIBLE';
export const MENU_ROUTE_IS_COLLAPSIBLE_SET = 'MENU_ROUTE_IS_COLLAPSIBLE_SET';
